import { render } from "./mail-password-change.vue?vue&type=template&id=fdc9f6c8"
import script from "./mail-password-change.vue?vue&type=script&lang=js"
export * from "./mail-password-change.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__